// ─────────────────────────────────────────────────────────────────────────────
// Fitistic theme tokens — White base with Black & Purple theme
// ─────────────────────────────────────────────────────────────────────────────

export const BRAND = {
  // Primary brand purple
  primary: '#7C3AED',
  primaryDark: '#6D28D9',
  primaryLight: '#8B5CF6',
  primarySoft: '#F5F3FF',
  primarySoftBorder: '#DDD6FE',

  // Black / neutral darks
  black: '#0F172A',
  blackDark: '#020617',
  cardDark: '#0F172A',
  cardDarkBorder: '#1E293B',
  cardDarkSurface: '#161F36',

  // White & light surfaces
  bg: '#F8FAFC',
  surface: '#FFFFFF',
  surfaceSoft: '#F1F5F9',
  textDark: '#0F172A',
  textMid: '#475569',
  textLight: '#94A3B8',
  divider: '#E2E8F0',

  // Semantic colours
  green: '#10B981',
  greenLight: '#D1FAE5',
  orange: '#F97316',
  orangeLight: '#FFEDD5',
  teal: '#06B6D4',
  tealLight: '#CFFAFE',
  pink: '#EC4899',
  purple: '#7C3AED',
  purpleLight: '#F5F3FF',
  yellow: '#EAB308',
  red: '#EF4444',
  redLight: '#FEE2E2',
  gold: '#F59E0B',
  goldLight: '#FEF3C7',
  blue: '#2563EB',
};

// Purple action gradient
export const PURPLE_GRADIENT = 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)';

// Black accent gradient
export const BLACK_GRADIENT = 'linear-gradient(135deg, #1E293B 0%, #0F172A 100%)';

// Aliases for compatibility
export const HERO_GRADIENT = PURPLE_GRADIENT;
export const BLUE_GRADIENT = PURPLE_GRADIENT;
export const SIDEBAR_GRADIENT = '#FFFFFF';

export const RADIUS = { sm: 8, md: 10, lg: 14, xl: 18 };

export const SHADOW = {
  card: '0 4px 16px rgba(15,23,42,0.04), 0 1px 3px rgba(0,0,0,0.02)',
  subtle: '0 1px 3px rgba(15,23,42,0.05)',
  hover: '0 10px 25px rgba(124,58,237,0.12), 0 2px 6px rgba(15,23,42,0.04)',
  glow: '0 8px 24px rgba(124,58,237,0.30)',
};
